import { render, staticRenderFns } from "./language-flag.vue?vue&type=template&id=755a6df5&"
import script from "./language-flag.vue?vue&type=script&lang=js&"
export * from "./language-flag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports